import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with your EmailJS service ID, template ID, and user ID
    emailjs.send('your_service_id', 'your_template_id', {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message
    }, 'your_user_id')
    .then((result) => {
      alert('Mensagem enviada com sucesso!');
      setFormData({ name: '', email: '', message: '' });
    }, (error) => {
      alert('Erro ao enviar mensagem. Tente novamente.');
      console.log(error.text);
    });
  };

  return (
    <section id="contact" data-aos="fade-up" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Entre em Contacto</h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="animate-slide-in-left">
            <h3 className="text-xl font-semibold mb-4">Fale Connosco</h3>
            <p className="text-gray-600 mb-4">
              Estamos aqui para ajudar. Entre em contacto connosco para saber mais sobre as nossas soluções Unisales.
            </p>
            <div className="space-y-2">
              <p><strong>Email:</strong> comercial@olimars.com</p>
              <p><strong>Telefone:</strong> +351 910373618(Chamada para a rede móvel nacional)</p>
              <p><strong>Endereço:</strong> Covilhã</p>
            </div>
          </div>
          <div className="animate-slide-in-right">
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="name"
                placeholder="Nome"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-3 border rounded hover:border-blue-500 transition duration-300"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-3 border rounded hover:border-blue-500 transition duration-300"
              />
              <textarea
                name="message"
                placeholder="Mensagem"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full p-3 border rounded h-32 hover:border-blue-500 transition duration-300"
              ></textarea>
              <button type="submit" className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition duration-300 transform hover:scale-105">
                Enviar Mensagem
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
